
import * as React from 'react';
import { isFileDropEvent } from '../../utilities/dragAndDrop/files';
import { asActionDropZone, IDecorateAsActionDropZoneProps } from '../decorators/asActionDropZone';
import { UploadEntriesAction, IUploadEntriesActionProps } from '../actions/upload/UploadEntriesAction';

export type IUploadDropZoneProps = IDecorateAsActionDropZoneProps<IUploadEntriesActionProps, {}>;

export const UploadDropZone: React.ComponentType<IUploadDropZoneProps> = asActionDropZone(isFileDropEvent)(UploadEntriesAction);
